/* eslint-disable */
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import {
  //   useAddAnswer,
  //   useNextQuestions,
  useDemoQuestionnaire,
  //   useSubmitQuiz,
} from "api/questionnaire";
import Loader from "components/Loader";
import { useEffect, useMemo, useState } from "react";
// import { showToast } from "utils/toast";
// import { ApiResponse } from "constantVariables";
import PrimaryButton from "components/common/Button/PrimaryButton";
import { useModal } from "context/hooks/useModal";
import HeaderSection from "components/HeaderSection";
import { t } from "i18next";

const reactions = [
  "_storngly_dislike",
  "_Dislike",
  "_Neutral",
  "_like",
  "_strongly_like",
];

export default function HollandCodeAttempt({ onFinish }) {
  const { id } = useParams();

  const { dir, language } = useAppSelector(getSettings);
  const { data, isLoading } = useDemoQuestionnaire(id);
  const [addingAnswer, setAddingAnswer] = useState(false);
  //   const { mutateAsync: addAnswer, isPending: addingAnswer } = useAddAnswer();
  //   const { showModal, hideModal } = useModal();
  //   const { mutateAsync: loadMoreQuestions, isPending: loadingNewQuestions } =
  //     useNextQuestions();
  //   const { mutateAsync: submitQuiz, isPending: submittingQuiz } =
  //     useSubmitQuiz();

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedReactions, setSelectedReactions] = useState("");
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);

  const isAllAnswered = useMemo(
    () => questions.every((ele) => ele.answer),
    [questions]
  );

  useEffect(() => {
    if (isAllAnswered) {
      // scroll to bottom
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }
  }, [isAllAnswered]);

  useEffect(() => {
    if (data) {
      let index = data?.questions.findIndex((ele) => !ele.answer);
      index = index === -1 ? data?.questions.length - 1 : index;
      setCurrentQuestion(index);
      setQuestions(data?.questions);
      setSelectedReactions(data?.questions[index].answer);
    }
  }, [data]);

  const loadNextQuestion = async () => {
    if (currentQuestion !== questions.length - 1) {
      setSelectedReactions(questions[currentQuestion + 1].answer);
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const loadPreviousQuestion = async () => {
    if (currentQuestion !== 0) {
      setSelectedReactions(questions[currentQuestion - 1].answer);
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const selectAnswer = (answer) => {
    setAddingAnswer(true);
    // addAnswer({
    //   id,
    //   ...question,
    // })
    //   .then((res) => {
    //     if (res.statusCode === ApiResponse.SUCCESS) {
    setTimeout(() => {
      const question = questions[currentQuestion];
      question.answer = answer;
      const newQuestions = [...questions];
      newQuestions[currentQuestion] = question;
      setSelectedReactions(answer);
      setQuestions(newQuestions);
      loadNextQuestion();
      setAddingAnswer(false);
    }, [200]);
    //     } else {
    //       showToast("Sorry couldn't add your answer right now", "error");
    //     }
    //   })
    //   .catch(() => {
    //     showToast("Sorry couldn't add your answer right now", "error");
    //   });
  };

  const submitQuiz = () => {
    const questionsCopy = [...questions];
    let result = {};
    questionsCopy.forEach((quest) => {
      if (result?.[quest.group]) {
        result[quest.group].score = result[quest.group].score + quest.answer;
      } else {
        result[quest.group] = {
          explanation: quest.explanation,
          group: quest.group,
          score: quest.answer,
        };
      }
    });
    Object.keys(result).forEach((key) => {
      result[key].score = result[key].score / (questions.length / 6);
  });
    const resultInArray = Object.values(result);

    onFinish({
      progress_precentage: 100,
      questionnaire: id,
      questions: questionsCopy,
      result: resultInArray.sort((a, b) => b.answer - a.answer),
    });
  };

  if (isLoading) return <Loader type="block" open />;
  if (!data) {
    navigate(-1);
    return <Loader type="block" open />;
  }
  return (
    <div dir={dir} className="bg-white">
      <HeaderSection bgImage={data?.cover_image} onBack="/register">
        <div className="">
          <h1 className="text-white font-bold text-4xl">
            {t("freeQuizTitle")}
          </h1>
        </div>
        <div></div>
      </HeaderSection>
      <div className="container flex flex-col justify-between gap-10 flex-1 mt-12 md:mt-28 pb-12 md:pb-20 relative">
        <Loader open={addingAnswer} type="block" />
        <div
          className="flex flex-col gap-10 bg-[#F5F5F5] w-full max-w-4xl m-auto p-4 md:p-6"
          style={{
            boxShadow: "0px 0px 4px 6px #00000040",
          }}
        >
          <p className="text-sm md:text-base">{t("quizWouldYouLike")}</p>
          <h1 className="text-center text-xl md:text-2xl" dir={dir}>
            {questions?.[currentQuestion]?.[language]}
          </h1>
          <div className="flex gap-1 mx-auto rtl:flex-row-reverse ltr:flex-row">
            <button
              onClick={loadPreviousQuestion}
              disabled={currentQuestion === 0}
            >
              <svg
                width="21"
                height="18"
                viewBox="0 0 21 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.16"
                  d="M2 10.7321C0.667 9.96214 0.667 8.03814 2 7.26814L11 2.07214C12.333 1.30214 14 2.26414 14 3.80414L14 14.1961C14 15.7361 12.333 16.6981 11 15.9281L2 10.7321Z"
                  className={`transition-all duration-500 ease-in-out ${
                    currentQuestion === 0 ? "fill-none" : "fill-[#5A70E8]"
                  }`}
                />
                <path
                  d="M14 3.80414L17 2.07214C18.333 1.30214 20 2.26414 20 3.80414V14.1961C20 15.7361 18.333 16.6981 17 15.9281L14 14.1961M14 3.80414L14 14.1961M14 3.80414C14 2.26414 12.333 1.30214 11 2.07214L2 7.26814C0.667 8.03814 0.667 9.96214 2 10.7321L11 15.9281C12.333 16.6981 14 15.7361 14 14.1961"
                  strokeWidth="2"
                  strokeLinejoin="round"
                  className={`transition-all duration-500 ease-in-out ${
                    currentQuestion === 0
                      ? "stroke-[#545454]"
                      : "stroke-[#5A70E8]"
                  }`}
                />
              </svg>
            </button>
            &nbsp;
            <p>
              {currentQuestion + 1}/{questions.length}
            </p>
            &nbsp;
            <button
              onClick={loadNextQuestion}
              disabled={!selectedReactions}
              className="disabled:cursor-not-allowed disabled:opacity-50"
            >
              <svg
                width="21"
                height="18"
                viewBox="0 0 21 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.16"
                  d="M19 7.26786C20.333 8.03786 20.333 9.96186 19 10.7319L10 15.9279C8.667 16.6979 7 15.7359 7 14.1959V3.80386C7 2.26386 8.667 1.30186 10 2.07186L19 7.26786Z"
                  className={`transition-all duration-500 ease-in-out ${
                    currentQuestion === questions.length - 1
                      ? "fill-none"
                      : "fill-[#5A70E8]"
                  }`}
                />
                <path
                  d="M7 14.1959L4 15.9279C2.667 16.6979 1 15.7359 1 14.1959V3.80386C1 2.26386 2.667 1.30186 4 2.07186L7 3.80386M7 14.1959V3.80386M7 14.1959C7 15.7359 8.667 16.6979 10 15.9279L19 10.7319C20.333 9.96186 20.333 8.03786 19 7.26786L10 2.07186C8.667 1.30186 7 2.26386 7 3.80386"
                  strokeWidth="2"
                  strokeLinejoin="round"
                  className={`transition-all duration-500 ease-in-out ${
                    currentQuestion === questions.length - 1
                      ? "stroke-[#545454]"
                      : "stroke-[#5A70E8]"
                  }`}
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          className={`mx-auto flex items-center gap-2 ${
            language === "he" ? "flex-row-reverse" : "flex-row"
          }`}
        >
          {reactions.map((reaction, index) => (
            <button
              onClick={() => selectAnswer(index + 1)}
              key={reaction}
              className="group disabled:cursor-not-allowed"
            >
              <img
                src={"/quiz/" + language + reaction + ".webp"}
                alt={reaction}
                className={`w-28 ${
                  selectedReactions && selectedReactions !== index + 1
                    ? "opacity-50"
                    : ""
                }`}
              />
            </button>
          ))}
        </div>
        {/* {isAllAnswered && questions.length === 30 ? (
          <div className="flex flex-col gap-5 items-center justify-center">
            <p className="text-xl">{t("quizAddNumOfQuestions")} 30</p>
            <PrimaryButton
              className="!bg-theme-yellow py-2 px-10 rounded-lg"
              onClick={async () => {
                await loadMoreQuestions(id);
                setSelectedReactions("");
              }}
            >
              {t("quizContinueMore")}
            </PrimaryButton>
          </div>
        ) : (
          ""
        )} */}
        {isAllAnswered ? (
          questions.length === 30 ? (
            <div className="flex flex-col gap-5 items-center justify-center">
              <p className="text-xl">{t("quizYouAnsweredAllQuestions")}</p>
              <PrimaryButton
                className="!bg-theme-yellow py-2 px-10 rounded-lg"
                onClick={submitQuiz}
              >
                {t("quizSubmit")}
              </PrimaryButton>
            </div>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

const AreYouSure = ({ onConfirm }) => {
  const { hideModal } = useModal();
  return (
    <div className="flex flex-col gap-10 py-6 px-10 items-center justify-center">
      <h1>{t("quizAreYouSure")}</h1>
      <div className="flex items-center justify-between w-full">
        <button
          className="text-lg text-theme-yellow underline text-center"
          onClick={hideModal}
        >
          {t("quizNotYet")}
        </button>
        <PrimaryButton
          className="!bg-theme-yellow py-2 px-10 rounded-lg"
          onClick={onConfirm}
        >
          {t("quizYes")}
        </PrimaryButton>
      </div>
    </div>
  );
};
